/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TenantAccountService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any
     * @throws ApiError
     */
    public putTenantAccountSetPassword({
        requestBody,
    }: {
        requestBody: {
            accountId?: string;
            password: string;
        },
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/tenant-account/password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public postTenantAccountEnrollFingerprint({
        requestBody,
    }: {
        requestBody: {
            accountId?: string;
            fmds: Array<string>;
        },
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/tenant-account/fingerprint',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
